import Vue from 'vue'
import moment from 'moment'
import { numberFormat } from '@/helpers'

Vue.filter('timeInHours', function (value) {
  let hours = parseInt(Math.floor(value / 360))
  let minutes = parseInt(Math.floor((value - (hours * 360)) / 60))
  let seconds = parseInt((value - ((hours * 360) + (minutes * 60))) % 60)

  let dHours = (hours > 9 ? hours : '0' + hours)
  let dMins = (minutes > 9 ? minutes : '0' + minutes)
  let dSecs = (seconds > 9 ? seconds : '0' + seconds)

  return dHours + ':' + dMins + ':' + dSecs
})

Vue.filter('timeVideo', function (seconds) {
  let minutes = Math.floor(seconds / 60)
  seconds = seconds % 60
  let hours = Math.floor(minutes / 60)
  minutes = minutes % 60

  return ((hours > 0) ? hours + 'h ' : '') + ((minutes > 0) ? minutes + 'm ' : '') + ((seconds > 0) ? seconds + 's ' : '')
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatDateContent', function (value) {
  if (value) {
    return `${moment(String(value)).format('DD/MM/YYYY')} às 08:00`
  }
})

Vue.filter('price', function (value) {
  return numberFormat(value, 2, ',', '.')
})
